import { CheckCircle, Target } from 'lucide-react';

/**
 * Progress tracker component for mobile
 * Encourages engagement by showing review progress
 */
const ProgressTracker = ({ reviewed, total }) => {
  const percentage = total > 0 ? Math.round((reviewed / total) * 100) : 0;
  
  // Get motivational message based on progress
  const getMessage = () => {
    if (percentage === 0) return "Start exploring today's signals";
    if (percentage < 25) return "Great start! Keep going";
    if (percentage < 50) return "You're making progress";
    if (percentage < 75) return "Halfway there!";
    if (percentage < 100) return "Almost done!";
    return "You've reviewed everything!";
  };
  
  return (
    <div 
      className="rounded-xl p-3 mb-4"
      style={{ 
        backgroundColor: 'rgba(34, 197, 94, 0.05)',
        border: '1px solid rgba(34, 197, 94, 0.12)'
      }}
      data-testid="progress-tracker"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Target className="h-4 w-4" style={{ color: '#4ade80' }} />
          <span className="text-sm" style={{ color: '#94A3B8' }}>
            You've reviewed{' '}
            <span className="font-semibold" style={{ color: '#4ade80' }}>
              {reviewed}
            </span>
            {' '}of{' '}
            <span className="font-semibold" style={{ color: '#F8FAFC' }}>
              {total}
            </span>
            {' '}anomalies today
          </span>
        </div>
        
        {percentage === 100 && (
          <CheckCircle className="h-4 w-4" style={{ color: '#4ade80' }} />
        )}
      </div>
      
      {/* Progress bar */}
      <div 
        className="h-1.5 rounded-full mt-2 overflow-hidden"
        style={{ backgroundColor: 'rgba(255,255,255,0.1)' }}
      >
        <div 
          className="h-full rounded-full transition-all duration-500"
          style={{ 
            width: `${percentage}%`,
            backgroundColor: '#4ade80'
          }}
        />
      </div>
      
      <p className="text-xs mt-2" style={{ color: '#64748B' }}>
        {getMessage()}
      </p>
    </div>
  );
};

export default ProgressTracker;
